
jQuery(function($)
{
    // counter - advantages
    let infoCounter = document.getElementsByClassName('js-information-counter');
    let counterNumber = 0;
    if (infoCounter.length > 0)
    {
        $(window).scroll(function()
        {
            var oTop = $('.js-counter-info-container').offset().top - window.innerHeight;
            if (counterNumber == 0 && $(window).scrollTop() > oTop)
            {
                const counters = document.querySelectorAll('.js-information-counter');
                const speed = 500;

                counters.forEach( counter =>
                {
                    const animate = () =>
                    {
                        const value = +counter.getAttribute('number');
                        const data = +counter.innerText;

                        const time = value / speed;
                        if (data < value)
                        {
                            counter.innerText = Math.ceil(data + time);
                            setTimeout(animate, 1);
                        }
                        else
                        {
                            counter.innerText = value;
                        }
                    };
                    animate();
                });
                counterNumber = 1;
            }
        });
    }
});
